import { FC, useMemo } from 'react';
import { SubmitButton } from '@/components/form/submit-button';
import { Button } from '@/components/ui/button';
import { strings } from '@/constants/strings';
import { useForm } from '@/forms/hooks/use-form';
import {
  buildSendNotificationFormSchema,
  SendNotificationFieldValues,
} from '@/forms/schemas/send-notification/schema';
import { DrawerContentFormLayout } from '@/layouts/drawer-content-form-layout';

export type SendNotificationFormProps = {
  onCancel: () => void;
  onSubmit: (values: SendNotificationFieldValues) => void;
};

export const SendNotificationForm: FC<SendNotificationFormProps> = ({
  onCancel,
  onSubmit,
}) => {
  const formSchema = useMemo(() => buildSendNotificationFormSchema(), []);

  const { fieldItems, handleSubmit } = useForm({
    schema: formSchema,
    onSubmit,
  });

  return (
    <DrawerContentFormLayout
      buttonItems={[
        <Button key="cancel" onClick={onCancel} variant="secondary">
          {strings.devices.drawer_announce.cancel}
        </Button>,
        <SubmitButton
          key="submit"
          text={strings.devices.drawer_announce.submit}
        />,
      ]}
      fieldItems={fieldItems}
      onSubmit={handleSubmit}
    />
  );
};
